// API réteg – SQLite backend hívások
const BASE = '/api';
const TOKEN_KEY = 'reviewfilter_token';

async function request(method, path, body) {
  const token = localStorage.getItem(TOKEN_KEY);
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Szerverhiba');
  return data;
}

export const initDb = () => {};

export const api = {
  // AUTH
  login: (email, password) =>
    request('POST', '/auth/login', { email, password }),
  changePassword: (currentPassword, newPassword) =>
    request('POST', '/auth/change-password', { currentPassword, newPassword }),
  impersonateAs: (businessId) =>
    request('POST', `/auth/impersonate/${businessId}`),

  // BUSINESSES
  getAllBusinesses: () => request('GET', '/businesses'),
  getBusinessById: (id) => request('GET', `/businesses/${id}`),
  createBusiness: (data) => request('POST', '/businesses', data),
  updateBusinessData: (id, data) => request('PUT', `/businesses/${id}`, data),
  deleteBusiness: (id) => request('DELETE', `/businesses/${id}`),
  getAdminUserForBusiness: (businessId) => request('GET', `/businesses/${businessId}/admin-user`),

  // LOCATIONS
  getLocations: (businessId) => request('GET', `/locations?businessId=${businessId}`),
  getAllLocations: () => request('GET', '/locations/all'),
  getLocationBySlug: (slug) => request('GET', `/locations/slug/${slug}`),
  addLocation: (businessId, data) => request('POST', '/locations', { businessId, ...data }),
  updateLocation: (id, data) => request('PUT', `/locations/${id}`, data),
  deleteLocation: (id) => request('DELETE', `/locations/${id}`),

  // REVIEWS & EVENTS
  getReviews: (businessId) => request('GET', `/reviews?businessId=${businessId}`),
  submitReview: (review) => request('POST', '/reviews', review),
  logEvent: (event) => request('POST', '/events', event),

  // USER MANAGEMENT
  getUsers: (role) => request('GET', `/users${role ? `?role=${role}` : ''}`),
  createUser: (data) => request('POST', '/users', data),
  updateUser: (userId, data) => request('PUT', `/users/${userId}`, data),
  setUserPassword: (userId, newPassword) => request('PUT', `/users/${userId}/password`, { newPassword }),
  deleteUser: (userId) => request('DELETE', `/users/${userId}`),

  // FAQ
  getFaq: () => request('GET', '/faq'),
  addFaq: (data) => request('POST', '/faq', data),
  updateFaq: (id, data) => request('PUT', `/faq/${id}`, data),
  deleteFaq: (id) => request('DELETE', `/faq/${id}`),

  // CONFIG
  getConfig: () => request('GET', '/config'),
  updateConfig: (data) => request('PUT', '/config', data),
  setConfig: (key, value) => request('PUT', '/config', { [key]: value }),
  testEmail: (to) => request('POST', '/config/test-email', { to }),

  // STATS
  getSuperAdminStats: () => request('GET', '/stats/superadmin'),
  getAdminDashboardStats: (businessId) => request('GET', `/stats/admin?businessId=${businessId}`)
};
